import { BCMSDate, BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, PositivePayCheck, PositivePayCheckFile } from "model";
import TASPositivePayImportChecksPage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayImportChecksPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import { useEffect } from "react";

/**
 * @name CapturePositivePayImportChecksSuccess2
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksSuccess2(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    defaultData.defaultTemplate.id = "0";
    defaultData.defaultTemplate.name = "Sample";
    defaultData.templates = [ defaultData.defaultTemplate ];

    const data = BCMSStateManagerCRUD.init(defaultData)
    .submit();

    const ui = BCMSStateManagerCRUD.init( getDefaultUI())
    .update([ "showSuccessHistoryBanner", "isActive" ], true)
    .submit();

    const nextID = parseFloat(PositivePayCheck.nextID());
    const allIDs = PositivePayCheck.initAll().reduce((acc, item) => {
        acc.push(item.id);
        return acc;
    }, []);
    const ids = [ 
        nextID,
        nextID + 1,
        nextID + 2,
        nextID + 3,
     ];
    let create = [];

    for(let i = 0; i < ids.length; i++) {
        if(!allIDs.includes(ids[i])) {
            const checkRecord = { id: ids[i], amount: i == 3 ? "46" : "0" }
            create.push(PositivePayCheck.create(checkRecord))
        }
    }

    // This batch function will render this component one additional time, 
    // so multiple checks above will be created. We only need the last four checks.
    BCMSRecord.batch(create, context, Classes);

    const lastFourChecksIDs = PositivePayCheck.initAll().slice(-4).reduce((acc, item) => {
        acc.push(item.id);
        return acc;
    }, []);

    defaultData.defaultHistory.checks = lastFourChecksIDs;

    return <TASPositivePayImportChecksPage data={ data } ui={ ui }  />;
}